import 'css-chunk:../authentication/frontend/pages/register-page/figure.module.scss';export default {
  "caption": "_caption_lsele_1",
  "faded": "_faded_lsele_20"
};